import {
  Sun,
  Zap,
  Battery,
  Layers,
  Gauge,
  Plug,
  ShieldCheck,
  Wrench,
  Cable,
  Cpu,
  Users,
  Package,
  Grip,
  Hash,
  HelpCircle,
  Snowflake,
  Fan,
  Thermometer,
  Droplets,
  Coins,
} from "lucide-react"

const ICONS: Record<
  string,
  { Icon: typeof Sun; color: string; label: string }
> = {
  panel: { Icon: Sun, color: "text-amber-500", label: "Painel" },
  inverter: { Icon: Zap, color: "text-sky-500", label: "Inversor" },
  battery: { Icon: Battery, color: "text-emerald-500", label: "Bateria" },
  structure: { Icon: Layers, color: "text-slate-500", label: "Suporte" },
  lancil: { Icon: Grip, color: "text-slate-400", label: "Lancil" },
  meter: { Icon: Gauge, color: "text-violet-500", label: "Medidor" },
  counter: { Icon: Hash, color: "text-cyan-600", label: "Contador" },
  charger: { Icon: Plug, color: "text-rose-500", label: "Carregador" },
  backup: { Icon: ShieldCheck, color: "text-indigo-500", label: "Backup" },
  installation: { Icon: Wrench, color: "text-orange-500", label: "Instalação" },
  installation_backup: {
    Icon: Cable,
    color: "text-indigo-400",
    label: "Inst. Backup",
  },
  installation_charger: {
    Icon: Cable,
    color: "text-rose-400",
    label: "Inst. Carregador",
  },
  battery_controller: {
    Icon: Cpu,
    color: "text-teal-500",
    label: "Controlador",
  },
  labour: { Icon: Users, color: "text-fuchsia-500", label: "Mão de Obra" },
  accessory: { Icon: Package, color: "text-stone-500", label: "Monitorização" },
  outros: { Icon: Coins, color: "text-teal-600", label: "Outros" },
  // AC / BC
  ac_monosplit: { Icon: Snowflake, color: "text-sky-600", label: "Monosplit" },
  indoor_unit: { Icon: Snowflake, color: "text-sky-500", label: "Unid. Interior" },
  outdoor_unit: { Icon: Fan, color: "text-cyan-600", label: "Unid. Exterior" },
  heat_pump: { Icon: Thermometer, color: "text-orange-500", label: "Bomba de Calor" },
  inertia_tank: { Icon: Droplets, color: "text-blue-600", label: "Depósito de Inércia" },
  dhw_tank: { Icon: Droplets, color: "text-red-500", label: "Termoacumulador" },
}

export function getRoleMeta(role?: string | null): {
  Icon: typeof Sun
  color: string
  label: string
} {
  if (role && ICONS[role]) return ICONS[role]
  return { Icon: HelpCircle, color: "text-muted-foreground", label: "Manual" }
}

export const ROLE_OPTIONS = [
  { value: "panel", label: "Painel" },
  { value: "inverter", label: "Inversor" },
  { value: "battery", label: "Bateria" },
  { value: "structure", label: "Estrutura de Suporte" },
  { value: "lancil", label: "Lancil" },
  { value: "meter", label: "Medidor" },
  { value: "counter", label: "Contador" },
  { value: "charger", label: "Carregador" },
  { value: "backup", label: "Backup" },
  { value: "installation", label: "Instalação" },
  { value: "installation_backup", label: "Inst. Backup" },
  { value: "installation_charger", label: "Inst. Carregador" },
  { value: "battery_controller", label: "Controlador Bateria" },
  { value: "labour", label: "Mão de Obra" },
  { value: "accessory", label: "Monitorização" },
  { value: "outros", label: "Outros" },
]

/** Role options per módulo (kit editor). Solar = lista completa acima. */
const AC_ROLE_OPTIONS = [
  { value: "ac_monosplit", label: "Monosplit" },
  { value: "indoor_unit", label: "Unidade Interior" },
  { value: "outdoor_unit", label: "Unidade Exterior" },
  { value: "installation", label: "Instalação" },
  { value: "accessory", label: "Acessório" },
  { value: "labour", label: "Mão de Obra" },
]

const BC_ROLE_OPTIONS = [
  { value: "heat_pump", label: "Bomba de Calor" },
  { value: "inertia_tank", label: "Depósito de Inércia" },
  { value: "dhw_tank", label: "Termoacumulador" },
  { value: "accessory", label: "Acessório" },
  { value: "installation", label: "Instalação" },
  { value: "labour", label: "Mão de Obra" },
]

export function roleOptionsForKind(
  kind: "solar" | "ac" | "bc_aqs" | "bc_aq",
): Array<{ value: string; label: string }> {
  switch (kind) {
    case "ac": return AC_ROLE_OPTIONS
    case "bc_aqs":
    case "bc_aq": return BC_ROLE_OPTIONS
    default: return ROLE_OPTIONS
  }
}
